<template>
  <section class="timeline">
    <div class="timeline__year">{{ data.year }}-</div>
    <div class="timeline__info">
      <div v-if="data.image" class="timeline__image">
        <figure>
          <img :src="data.image" alt="Alt description for the image">
        </figure>
      </div>
      <h2 class="timeline__title">{{ data.titles }}</h2>
      <p class="timeline__text">{{ data.details }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CardTimeline',
  components: {},
  props: ['data']
}
</script>

<style lang="postcss">
.timeline {
  @apply w-full border border-t-0 border-l-0 border-r-0 border-body-lighter flex flex-col py-8;
}
.timeline:first-of-type {
  @apply pt-0;
}
.timeline__year {
  @apply text-10xl font-bold text-secondary-lighter leading-none overflow-visible w-5/12;
}
.timeline__info {
  @apply w-full;
}
.timeline__image {
  @apply mb-6;
}
.timeline__image figure {
  @apply block aspect-ratio-4/3 relative overflow-hidden;
}
.timeline__image img {
  @apply block absolute inset-y-0 inset-x-0 min-w-full min-h-full;
}
.timeline__title {
  @apply text-secondary font-semibold;
}
.timeline__text {
  @apply text-lg;
}
@screen md {
  .timeline {
    @apply flex-row py-16;
  }
  .timeline__year {
    @apply text-14xl;
  }
  .timeline__image {
    @apply max-w-2/3;
  }
  .timeline__info {
    @apply w-7/12;
  }
}
@screen lg {
  .timeline__year {
    @apply w-5/12;
  }
  .timeline__info {
    @apply w-1/2;
  }
}
</style>
